import React from 'react'

const CheckCircle = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.8768 1.63121L5.87701 1.63112C6.85478 1.20947 7.89747 1 9 1C10.1025 1 11.1452 1.20947 12.123 1.63112L12.1232 1.63121C13.0913 2.0492 13.9383 2.61871 14.6598 3.3402C15.3813 4.06174 15.9506 4.90887 16.3681 5.87701C16.7903 6.85477 17 7.89746 17 9C17 10.1025 16.7903 11.1452 16.3681 12.123C15.9506 13.0911 15.3813 13.9383 14.6598 14.6598C13.9383 15.3813 13.0911 15.9506 12.123 16.3681C11.1452 16.7903 10.1025 17 9 17C7.89746 17 6.85477 16.7903 5.87701 16.3681C4.90887 15.9506 4.06174 15.3813 3.3402 14.6598C2.61866 13.9383 2.04937 13.0911 1.63187 12.123C1.20973 11.1452 1 10.1025 1 9C1 7.89746 1.20973 6.85477 1.63187 5.87701L5.8768 1.63121ZM5.8768 1.63121C4.90875 2.0492 4.06169 2.61871 3.3402 3.3402C2.61871 4.06168 2.04945 4.90874 1.63196 5.8768L5.8768 1.63121Z" fill="#F9FAFE" stroke="#D6DBF7"/>
    </svg>
    
  )
}

export default CheckCircle
